<div class="ds-onboarding-input">
  <div class="ds-input-primary">
    <div class="ds-input-primary-content">
      <input [formControl]="inputControl" [placeholder]="onboardingFlowStep?.placeholder" [ngClass]="{'invalid-input': inputControl.invalid && (inputControl.dirty || inputControl.touched)}"/>

      <div class="floating-input-totalum-logo" *ngIf="onboardingFlowStep?.validation?.totalumName">
        <ng-container *ngIf="!inputLoader">
          <img src="assets/totalum-logo-recortado.png" alt="Totalum logo">
        </ng-container>
        <ng-container *ngIf="inputLoader">
          <ion-spinner></ion-spinner>
        </ng-container>
      </div>
    </div>
    <div class="ds-input-primary-label" *ngIf="inputControl.invalid && (inputControl.dirty || inputControl.touched)">
      <span *ngIf="inputControl.errors?.['required']">{{ 'ERRORS.REQUIRED' | translate }}</span>
      <span *ngIf="inputControl.errors?.['email']">{{ 'ERRORS.INVALID_EMAIL' | translate }}</span>
      <span *ngIf="inputControl.errors?.['errorDelivery']">{{ 'ERRORS.ERROR_DELIVERY' | translate }}</span>
      <span *ngIf="inputControl.errors?.['emailFraud']">{{ 'ERRORS.EMAIL_FRAUD' | translate }}</span>
      <span *ngIf="inputControl.errors?.['totalumNameInvalid']">{{ 'ERRORS.TOTALUM_NAME_INVALID' | translate }}</span>
      <span *ngIf="inputControl.errors?.['totalumNameExists']">{{ 'ERRORS.TOTALUM_NAME_EXISTS' | translate }}</span>
      <span *ngIf="inputControl.errors?.['totalumNameShort']">{{ 'ERRORS.TOTALUM_NAME_SHORT' | translate }}</span>
      <span *ngIf="inputControl.errors?.['totalumNameLong']">{{ 'ERRORS.TOTALUM_NAME_LONG' | translate }}</span>
      <span *ngIf="inputControl.errors?.['tokenInvalid']">{{ 'ERRORS.TOKEN_INVALID' | translate }}</span>
      <span *ngIf="inputControl.errors?.['tooManyIntents']">{{ 'ERRORS.TOO_MANY_INTENTS' | translate }}</span>

    </div>
  </div>
</div>